import { render } from "./TimetablePreview.vue?vue&type=template&id=15b92140"
import script from "./TimetablePreview.vue?vue&type=script&lang=js"
export * from "./TimetablePreview.vue?vue&type=script&lang=js"

import "./TimetablePreview.vue?vue&type=style&index=0&id=15b92140&lang=css"
script.render = render

export default script